import React, {useEffect, useState} from 'react';

export function Age({date}) {
  const [dateFormatted, setDateFormatted] = useState('');

  useEffect(() => {
    if (date) {
      try {
        const now = new Date();
        const dt = new Date(date);
        if (dt.getFullYear() === 1) {
          return '';
        }
        let diff = 0;
        if ((now.getMonth() < dt.getMonth()) || (now.getMonth() === dt.getMonth() && now.getDate() < dt.getDate())) {
          diff = -1;
        }
        const age = (now.getFullYear() - dt.getFullYear() + diff);
        const last = ('' + age).slice(-1) * 1;
        setDateFormatted(age + (last === 1 ? ' год' : (last > 1 && last < 5 ? ' года' : ' лет')));
      } catch (e) {
        console.log('Unable to get age from date ' + date);
        setDateFormatted('');
      }
    } else {
      setDateFormatted('');
    }
  }, [date]);

  return <React.Fragment>
    {dateFormatted}
  </React.Fragment>;
}
